import React from "react";
import styled from "styled-components";

import caLogo from "../../assets/YogashastraClear.png";

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  width: 210px;

  img {
    display: block;
    width: 210px;
    height: auto;
    max-width: none;
    object-fit: contain;
  }

  @media (max-width: 860px) {
    width: 170px;

    img {
      width: 170px;
    }
  }

  @media (max-width: 480px) {
    width: 145px;

    img {
      width: 145px;
    }
  }
`;

const Logo = (props) => {
  return (
    <LogoWrapper {...props}>
      <img
        src={caLogo}
        alt="Yoga Shastra"
      />
    </LogoWrapper>
  );
};

export default Logo;